module.exports = __webpack_public_path__ + "static/media/js_logo.03cbde69.jpg";